<template>
  <div class="app-login-wrapper">
    <slot name="txtBefore"></slot>
    <UserInfo LogIn v-if="loggedIn">
      <template v-for="slot in possibleChildSlotsFor('UserInfo')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </UserInfo>
    <LogIn v-else>
      <template #txtBefore><slot name="txtLoginBefore"></slot></template>
      <template #lblBefore><slot name="lblLoginBefore"></slot></template>
      <template #lblUsername><slot name="lblLoginUsername"></slot></template>
      <template #lblBetween><slot name="lblLoginBetween"></slot></template>
      <template #lblPassword><slot name="lblLoginPassword"></slot></template>
      <template #btnNext><slot name="btnLoginNext"></slot></template>
      <template #txtAfter><slot name="txtLoginAfter"></slot></template>
    </LogIn>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import LogIn from './LoginComponent.vue'
import UserInfo from './UserInfo.vue'
import { onLogout as apolloLogout } from '@/apollo'
import { PERSISTENCE_KEY } from '@/store/config'
import { mapActions, mapGetters } from 'vuex'
import slotProxy from '../../../../../mixins/slotProxy'

export default {
  name: 'LogInWrapper',
  components: {
    LogIn,
    UserInfo
  },
  mixins: [
    slotProxy()
  ],
  computed: {
    loggedIn () {
      if (!this.$store) {
        return false
      }
      if (this.checkContaoLogin() === false) {
        // if true contao is logged in, if null not embedded
        return false
      }
      return this.isAuthenticated
    },
    ...mapGetters(['isAuthenticated'])
  },
  methods: {
    checkContaoLogin () {
      const portalLoginForm = document.querySelector('form.mod_login')
      if (portalLoginForm) {
        return portalLoginForm.classList.contains('logout')
      }
      return null
    },
    ...mapActions(['logout'])
  },
  beforeMount () {
    if (this.checkContaoLogin() === false && this.isAuthenticated) {
      this.logout()
      sessionStorage.removeItem(PERSISTENCE_KEY)
      apolloLogout(this.$apolloProvider.defaultClient)
    }
  }
}
</script>
